function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Iedit = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02114 17L2 21.1139C2 21.346 2.08457 21.5781 2.2537 21.7468C2.42283 21.9156 2.63425 22 2.86681 22L6.96829 21.9789C7.20085 21.9789 7.41226 21.8945 7.5814 21.7257L21.7463 7.59072C22.0846 7.25317 22.0846 6.70464 21.7463 6.34599L17.6871 2.25317C17.3488 1.91561 16.7992 1.91561 16.4397 2.25317L13.6068 5.10127L2.27484 16.3882C2.12685 16.557 2.02114 16.7679 2.02114 17ZM17.074 4.10938L19.9281 6.95748L18.3213 8.56085L15.4672 5.71275L17.074 4.10938ZM14.2197 6.96094L3.7757 17.3829L3.75456 20.231L6.62982 20.2099L17.0738 9.80904L14.2197 6.96094Z",
    fill: "#495057"
  }));
});